// extracted by mini-css-extract-plugin
module.exports = {"buttons":"VehicleKillQuestions_buttons__vQ-RX"};